import React                from 'react'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas }     from '@fortawesome/free-solid-svg-icons'
library.add(fas)

import { CalendarProvider } from './useCalendar';

// components
import Calendar                   from './calendar'

const App = ({ props }) => {
  return (
    <CalendarProvider props={props}>
      <Calendar />
    </CalendarProvider>
  )
}

export default App
